import PayUSecureForm, { PayUSpecificSecureFormProps } from '../PayUSecureForm/PayUSecureForm';

const PayUNumberSecureForm = (props: PayUSpecificSecureFormProps) => (
    <PayUSecureForm formType="number" {...props} />
);

export default PayUNumberSecureForm;
